import React from "react";
import { useNavigate } from "react-router-dom";

export default function MembershipsSectionPricing2() {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/about");
  };

  return (
    <React.Fragment>
      <section className="pt-24 pb-28 bg-blueGray-50 overflow-hidden">
        <div className="container px-4 mx-auto">
          <h2 className="mb-24 text-6xl md:text-7xl font-bold font-heading text-center tracking-px-n leading-tight md:max-w-xl mx-auto">
            Elige el plan que más se adapte a ti.
          </h2>
          <div className="mb-24 md:max-w-6xl mx-auto">
            <div className="flex flex-wrap -m-4">
              {/* Plan 1: Novo Seniors */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-3 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Novo Seniors (Personas de 55 años o más)
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $29/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $29.00 mensual, 2 meses x $55.00 o 3 meses x $74.00
                      <br />
                      - $10.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>
                        Entrenamiento Individual Ilimitado (Lunes a Sábado)
                      </li>
                      <li>Guía de rutinas básica</li>
                      <li>Guía básica de alimentación</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>

              {/* Plan 2: Novo Family (Dos personas) */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Novo Family (Dos personas)
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $80/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $80.00 mensual
                      <br />
                      - $20.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                      <br />- Oferta válida mientras todos los participantes se
                      mantengan activos
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>
                        Entrenamiento individual ilimitado (Lunes a Sábado)
                      </li>
                      <li>Guía de rutinas básica</li>
                      <li>Guía básica de alimentación</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>

              {/* Plan 3: Novo Family (Tres personas) */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Novo Family (Tres personas)
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $115/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $115.00 mensual
                      <br />
                      - $20.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                      <br />- Oferta válida mientras todos los participantes se
                      mantengan activos
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>
                        Entrenamiento individual ilimitado (Lunes a Sábado)
                      </li>
                      <li>Guía de rutinas básica</li>
                      <li>Guía básica de alimentación</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>

              {/* Plan 4: Servidor Público */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Servidor Público (Toda persona que trabaje con alguna
                      agencia gubernamental/Enfermeros)
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $35/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $35.00 mensual
                      <br />
                      - $10.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>
                        Entrenamiento individual ilimitado (Lunes a Sábado)
                      </li>
                      <li>Guía de rutinas básica</li>
                      <li>Guía básica de alimentación</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>

              {/* Plan 5: Atletas */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Atletas (Deberá proveer certificacion o ID de la organización a la que pertenece)
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $31.50/mes
                    </h3>
                    
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>
                        Entrenamiento individual ilimitado (Lunes a Sábado)
                      </li>
                      <li>Guía de rutinas básica</li>
                      <li>Guía básica de alimentación</li>
                      <li>Sala de espera para niños</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>

              {/* Plan 6: Entrenamiento Individual */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Entrenamiento Individual
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $45/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $45.00 mensual, 2 meses x $85.00, 3 meses x $120.00, 6
                      meses x $198.00, 1 año x $348.00
                      <br />
                      - $10.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>
                        Entrenamiento individual ilimitado (Lunes a Sábado)
                      </li>
                      <li>Guía de rutinas básica</li>
                      <li>Guía básica de alimentación</li>
                      <li>Sala de espera para niños</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>

              {/* Plan 7: Entrenamiento Personal (16 días) */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Entrenamiento Personal (16 días)
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $220/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $220.00 mensual
                      <br />
                      - $0.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>Periodización de entrenamiento</li>
                      <li>Evaluación mensual</li>
                      <li>Acceso ilimitado al gimnasio de lunes a sábado</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>

              {/* Plan 8: Entrenamiento Personal (12 días) */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Entrenamiento Personal (12 días)
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $175/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $175.00 mensual
                      <br />
                      - $0.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>Periodización de entrenamiento</li>
                      <li>Evaluación mensual</li>
                      <li>Acceso ilimitado al gimnasio de lunes a sábado</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>

              {/* Plan 9: Entrenamiento Personal (8 días) */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Entrenamiento Personal (8 días)
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $130/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $130.00 mensual
                      <br />
                      - $0.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>Periodización de entrenamiento</li>
                      <li>Evaluación mensual</li>
                      <li>Acceso ilimitado al gimnasio de lunes a sábado</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>
              {/* Plan 10: Oferta Gold*/}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Membresía Gold
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $65/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $65.00 mensual
                      <br />
                      - $20.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                      <br />- Oferta válida mientras todos los participantes se
                      mantengan activos
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>
                        Entrenamiento individual ilimitado (Lunes a Sábado)
                      </li>
                      <li>Guía de rutinas personalizada con videos explicativos.</li>
                      <li>Plan con sugerencias alimentarias.</li>
                      <li>Posibilidad de traer un invitado los viernes.</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>

              {/* Plan 10: Oferta para Estudiantes */}
              <div className="w-full md:w-1/3 p-4">
                <div
                  className="flex flex-col justify-between px-9 pt-8 pb-9 h-full bg-white bg-opacity-90 border-blueGray-100 rounded-4xl"
                  style={{ backdropFilter: "blur(46px)", minHeight: "400px" }}
                >
                  <div>
                    <span className="mb-4 inline-block text-sm text-blue-NV font-semibold uppercase tracking-px leading-snug">
                      Oferta para Estudiantes (Deberá presentar ID de
                      estudiante)
                    </span>
                    <h3 className="mb-3 text-4xl text-gray-900 font-bold leading-none">
                      $35/mes
                    </h3>
                    <p className="mb-6 text-sm text-gray-600 font-medium leading-relaxed">
                      - $35.00 mensual
                      <br />
                      - $10.00 matrícula
                      <br />- $30.00 cuota anual de mantenimiento
                    </p>
                    <h4 className="mb-3 text-2xl text-gray-900 font-semibold leading-none">
                      Incluye:
                    </h4>
                    <ul className="mb-6 text-sm text-gray-600 font-medium leading-relaxed list-disc pl-5">
                      <li>
                        Entrenamiento individual ilimitado (Lunes a Sábado)
                      </li>
                      <li>Guía de rutinas básica</li>
                      <li>Guía básica de alimentación</li>
                    </ul>
                  </div>
                  <div className="mt-auto">
                    <button
                      className="py-4 px-9 w-full font-semibold border border-blueGray-300 hover:border-blueGray-400 rounded-xl focus:ring focus:ring-gray-50 bg-blue-NV text-white hover:bg-gray-50 transition ease-in-out duration-200"
                      type="button"
                      onClick={handleButtonClick}
                    >
                      Conócenos
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="mb-4 text-sm text-gray-500 text-center font-medium leading-relaxed">
            Confiado por servicios de pago seguros
          </p>
          <div className="flex flex-wrap justify-center">
            <div className="w-auto">
              <a href="#">
                <img
                  src="https://static.shuffle.dev/uploads/files/6e/6e0f5129d29c66a42389554d32247ff33a40eeff/ath-logo-vector-svg-1719684351283-webp-1719684411421.webp"
                  alt="ATH Logo"
                />
              </a>
            </div>
            <div className="w-auto">
              <a href="#">
                <img src="flaro-assets/logos/brands/amex.svg" alt="Amex Logo" />
              </a>
            </div>
            <div className="w-auto">
              <a href="#">
                <img
                  src="flaro-assets/logos/brands/mastercard.svg"
                  alt="Mastercard Logo"
                />
              </a>
            </div>
            <div className="w-auto">
              <img
                src="flaro-assets/logos/brands/paypal.svg"
                alt="Paypal Logo"
              />
            </div>
            <div className="w-auto">
              <a href="#">
                <img src="flaro-assets/logos/brands/visa.svg" alt="Visa Logo" />
              </a>
            </div>
            <div className="w-auto">
              <a href="#">
                <img
                  src="flaro-assets/logos/brands/apple-pay.svg"
                  alt="Apple Pay Logo"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
